import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChartLineUp, Brain, Heartbeat } from "@phosphor-icons/react";
import { PredictiveAnalytics } from "./PredictiveAnalytics";
import { SentimentAnalysis } from "./SentimentAnalysis";
import { AIAssistant } from "./AIAssistant";

export function AnalyticsDashboard() {
  const [activeTab, setActiveTab] = useState("predictive");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500 relative">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          AI & Analytics
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Data-driven insights and AI-powered recommendations.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 lg:w-auto">
          <TabsTrigger value="predictive" className="gap-2">
            <Brain className="w-4 h-4" />
            <span className="hidden md:inline">Predictive AI</span>
          </TabsTrigger>
          <TabsTrigger value="sentiment" className="gap-2">
            <Heartbeat className="w-4 h-4" />
            <span className="hidden md:inline">Sentiment Pulse</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="predictive" className="space-y-4">
            <PredictiveAnalytics />
          </TabsContent>

          <TabsContent value="sentiment" className="space-y-4">
            <SentimentAnalysis />
          </TabsContent>
        </div>
      </Tabs>

      {/* Floating AI Assistant - Always visible in this section */}
      <AIAssistant />
    </div>
  );
}
